import { render, staticRenderFns } from "./MenuFilePicker.vue?vue&type=template&id=5107a899&scoped=true&"
import script from "./MenuFilePicker.vue?vue&type=script&lang=js&"
export * from "./MenuFilePicker.vue?vue&type=script&lang=js&"
import style0 from "./MenuFilePicker.vue?vue&type=style&index=0&id=5107a899&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107a899",
  null
  
)

export default component.exports